module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAMAAAC3SZ14AAAATlBMVEUAAABOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnpOWnqE7lcFAAAAGXRSTlMA7+nfJbxkSBjmy7OlkkEfEaqZh2xdVjYg6dEJSgAAAHJJREFUGNN10EkOhDAMRFHbgSTN3My+/0UhwZAYib98Um0KJEtkQeX5zCsqAhUZbJUJZKruloFYwkHI8tMsNCVqhdpEo9A/US1kEtElHWe5SGVOZZCVVQuAR03YQ60gTn9vQnAvMw6+6jFOdnVhQ9TIhQfyqhK1TkWKuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_notice1_hover.png
// module id = jcNU
// module chunks = 9